import { customStyles } from "~/src/components/common/Select/styles";

/** Funnel / popup import tables: escape horizontal scroll clipping for react-select menus. */
export const popupImportSelectWithMenuPortalProps = {
  menuPortalTarget: typeof document !== "undefined" ? document.body : undefined,
  menuPosition: "fixed" as const,
  styles: {
    ...customStyles,
    menuPortal: (base: Record<string, unknown>) => ({ ...base, zIndex: 9999 }),
  },
};
